import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

import { removeDataFromMap, setDatabotsNavMap } from 'js/vue/helpers';

var databots = {
    activity: 'prospect-overview__menu--activity',
    informations: 'prospect-overview__menu--general-info',
    financialactivity: 'prospect-overview__menu--financial-info',
    contacts: 'prospect-overview__menu--contact-linked',
    addresses: 'prospect-overview__menu--address',
    customfields: 'prospect-overview__menu--cf',
    statistics: 'prospect-overview__menu--stat',
    opportunity: 'prospect-overview__menu--opportunity',
    estimate: 'prospect-overview__menu--document',
    invoice: 'prospect-overview__menu--document',
    delivery: 'prospect-overview__menu--document',
    order: 'prospect-overview__menu--document',
    creditnote: 'prospect-overview__menu--document',
    proforma: 'prospect-overview__menu--document',
    payments: 'prospect-overview__menu--payment',
    bankaccount: 'prospect-overview__menu--bank-account',
    recurring: 'prospect-overview__menu--recurring',
    mandates: 'prospect-overview__menu--mandate',
    timetracking: 'prospect-overview__menu--timetracking',
    tickets: 'prospect-overview__menu--ticket',
    project: 'prospect-overview__menu--project',
    proposal: 'prospect-overview__menu--proposal',
    emailingprofile: 'prospect-overview__menu--mailing-list',
    massmailingMailinglist: 'prospect-overview__menu--mailing-list',
    massmailingCampaignList: 'prospect-overview__menu--mailing-list',
    receipts: 'prospect-overview__menu--receipt',
    briefcase: 'prospect-overview__menu--briefcase',
    activitycommentadd: 'prospect-overview__activity--comment-add',
    emailadd: 'prospect-overview__activity--email-add',
    calladd: 'prospect-overview__activity--call-add',
    scheduledcalladd: 'prospect-overview__activity--scheduled-call-add',
    taskadd: 'prospect-overview__activity--task-add',
    eventadd: 'prospect-overview__activity--event-add',
    generalinfoedit1: 'prospect-overview__section--general-info-edit-1',
    generalinfoedit2: 'prospect-overview__section--general-info-edit-2',
    marketing: 'prospect-overview__section--marketing',
};

setDatabotsNavMap(navMap, databots);

const dataToRemove = [
    {
        key: 'financial',
        values: ['account', 'auxiliaryCode'],
    },
];

removeDataFromMap(dataToRemove, dataMap);

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'prospect',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'prospect-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'prospect-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'prospect-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'prospect-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'prospect-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'prospect-overview__activity--marketing-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'prospect',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'prospect',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = ['estimate_third'];

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
